import { useNavigate, useLocation } from 'react-router-dom';

import { clearGetParameters } from '@gem/utils';

export function useClearGetParameters(
  fields: Array<string | [string, string]> = [],
  isReplace = false
): () => void {
  const location = useLocation();
  const navigate = useNavigate();

  return () => {
    navigate(clearGetParameters({ location, fields }), { replace: isReplace });
  };
}
